import { Directive, ElementRef, OnInit } from '@angular/core';

@Directive({
  selector: '[appAnimateOnce]',
})
export class AnimateOnceDirective implements OnInit {
  constructor(private el: ElementRef) {}

  ngOnInit() {
    this.animateIn();
  }

  animateIn() {
    this.el.nativeElement.classList.add('animated');
  }
}
